import Button, { EButtonVariant } from "components/elements/Button";
import Modal from "components/elements/Modal";
import Typography, { ITypo } from "components/elements/Typography";
import I18n from "components/materials/I18n";

import classes from "./classes.module.scss";

type IProps = {
	isOpen: boolean;
	onClose: () => void;
	onNo: () => void;
	onYes: () => void;
};

export default function AskCoSubscriberModal(props: IProps) {
	const { isOpen, onClose, onNo, onYes } = props;

	return (
		<Modal isOpen={isOpen} onClose={onClose} className={classes["root"]}>
			<Typography typo={ITypo.H1}>{I18n.asset.pages.mo_manual_subscription.modal_ask_co_subscriber.title}</Typography>
			<Typography typo={ITypo.P_MEDIUM_BOLD}>{I18n.asset.pages.mo_manual_subscription.modal_ask_co_subscriber.text}</Typography>
			<div className={classes["button-container"]}>
				<Button variant={EButtonVariant.OUTLINED} onClick={onNo}>
					{I18n.asset.common.no}
				</Button>
				<Button onClick={onYes}>{I18n.asset.common.yes}</Button>
			</div>
		</Modal>
	);
}
